import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { differenceInMinutes, parseISO } from "date-fns";

interface FocusModeActiveIndicatorProps {
  bonusPoints: number;
  shiftEndAt: string;
}

export function FocusModeActiveIndicator({
  bonusPoints,
  shiftEndAt,
}: FocusModeActiveIndicatorProps) {
  const currentDate = useCurrentDate(60_000);
  const minutesRemaining = differenceInMinutes(parseISO(shiftEndAt), currentDate);

  return (
    <Card
      sx={(theme) => ({
        backgroundColor: theme.palette.success.light,
        borderRadius: theme.shape.borderRadius,
      })}
    >
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="subtitle2" sx={(theme) => ({ color: theme.palette.success.dark })}>
            Focus Mode Active
          </Typography>
          <Typography variant="body2">
            {bonusPoints} bonus points at stake &middot; {Math.max(0, minutesRemaining)} min
            remaining
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
